<div *ngIf="loadingPanelId" class="loadpanel">
  <!-- Replace with Angular equivalent load panel -->
  <div *ngIf="isLoadingPanelVisible" class="loading-indicator">
    <!-- You can integrate a loading panel library like DevExtreme or custom CSS here -->
    Loading...
  </div>
</div>

<div class="hpanel" [id]="loadingPanelId">
  <div class="panel-heading hbuilt" *ngIf="panelTitle">
    <div class="panel-tools">
      <ng-content select="panel-tools"></ng-content>
      <a href="#" (click)="showHidePanel($event)">
        <i class="fa fa-chevron-up"></i>
      </a>
    </div>
    <strong>{{ panelTitleBold | uppercase }}</strong>
    {{ panelTitle | uppercase }}
  </div>

  <div class="panel-body">
    <ng-content select="panel-body"></ng-content>
  </div>

  <div class="panel-footer" *ngIf="showFooter">
    <ng-content select="panel-footer"></ng-content>
  </div>
</div>
